import { ThemesModeEnum } from 'config';
import { IGlobalSearchOutput } from 'services/api/globalsearch';
import { IAction, KEEP_THE_SAME, StateStatus } from '../../utils/common';
import * as Types from './types';

interface IInterest {
  savedSearch: number | null;
  favourites: number | null;
}

export interface IItemCollection {
  id: number;
  name: string;
  item: number | string;
}

export interface IState {
  interest: {
    status: StateStatus | null;
    data: IInterest | null;
  };
  globalSearch: {
    status: StateStatus | null;
    data: IGlobalSearchOutput | null;
  };
  Customer_NotificationsList: {
    status: StateStatus | null;
    data: any;
  };
  editCustomer_Notifications: {
    status: StateStatus | null;
  };
}

const initialState: IState = {
  interest: {
    status: null,
    data: null,
  },
  globalSearch: {
    status: null,
    data: null,
  },
  Customer_NotificationsList: {
    status: null,
    data: null,
  },
  editCustomer_Notifications: {
    status: null,
  },
};

const CommonReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_INTEREST:
      return {
        ...state,
        interest: {
          ...state.interest,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME ? state.interest.data : action.data,
        },
      };
    case Types.SET_GLOBAL_SEARCH:
      return {
        ...state,
        globalSearch: {
          ...state.globalSearch,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.globalSearch.data
              : action.data,
        },
      };
    case Types.SET_CUSTOMER_NOTIFICATIONS_LIST:
      return {
        ...state,
        Customer_NotificationsList: {
          ...state.Customer_NotificationsList,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.Customer_NotificationsList.data
              : action.data,
        },
      };
    case Types.SET_EDIT_CUSTOMER_NOTIFICATIONS:
      return {
        ...state,
        editCustomer_Notifications: {
          ...state.editCustomer_Notifications,
          status: action.status || null,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default CommonReducer;
